export const environment = {
  environment: 'staging',
  positizeHubUrl: 'https://hub.staging.positize.app',
};
